export function setCookie(cName: string | undefined, cValue: string, maxAgeInSeconds?: number) {
	if (cName) {
		if (maxAgeInSeconds !== undefined) {
			document.cookie = `${cName}=${cValue};max-age=${maxAgeInSeconds};path=/`;
		}
		else {
			document.cookie = `${cName}=${cValue};path=/`
		}
	}
}

export function deleteCookie(cName: string | undefined) {
	if (cName) {
		document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}
}

export async function getCookieValue(cName: string | undefined): Promise<string | null> {
	if (cName) {
		let cookieArr = document.cookie.split(";");
		for(const cookie of cookieArr) {
			if (cookie.indexOf(cName) !== -1) {
				const cookiePair = cookie.split("=");
				return decodeURIComponent(cookiePair[1]);
			}
		}
	}
	
	return null;
}

export function setCookieWithDomain(cName: string | undefined, cValue: string, maxAgeInSeconds?: number, domain?: string) {
	if (cName) {
		if (maxAgeInSeconds !== undefined) {
			document.cookie = `${cName}=${cValue};max-age=${maxAgeInSeconds};domain=${domain};path=/`;
		}
		else {
			document.cookie = `${cName}=${cValue};domain=${domain};path=/`;
		}
	}
}

/* no for loop - if we ever want to be even more efficient, but it is less readable!
function get_cookie(cookie_name) {
	const value = "; " + document.cookie;
	const parts = value.split("; " + cookie_name + "=");
	if (parts.length === 2) 
		return parts.pop().split(";").shift();
	else
		return null; // this will never happen, because it is impossible to have 2 cookies with the same name
}
*/